export abstract class OverlayWrapper<T> {

  data: T;

}
